import { useEffect, useState } from "react";

// weekday (0=Dom) -> [abre, fecha] em horas, fuso de Ibitinga
const HOURS = { 1: [9, 18], 2: [9, 18], 3: [9, 18], 4: [9, 18], 5: [9, 18], 6: [9, 12] };
const DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

const isOpenNow = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Sao_Paulo", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const range = HOURS[DAYS[get("weekday")]];
  if (!range) return false;
  const h = Number(get("hour")) + Number(get("minute")) / 60;
  return h >= range[0] && h < range[1];
};

export const useOpenStatus = () => {
  const [open, setOpen] = useState(isOpenNow);
  useEffect(() => {
    const id = setInterval(() => setOpen(isOpenNow()), 60000);
    return () => clearInterval(id);
  }, []);
  return open;
};
